import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";
import Layout from "app/components/layouts";
import PartOne from "app/components/joint/employment/PartOne";
import PartTwo from "app/components/joint/employment/PartTwo";
import PreviousEmployer from "app/components/joint/employment/PreviousEmployer";
import SecondEmployment from "app/components/joint/employment/SecondEmployment";
import { StepsComponent } from "app/utils/types";
import JointStepper from "app/components/common/JointStepper";

const JointEmploymentDetails: React.FC = () => {
  const currentStep = useSelector(
    (state: RootState) => state.jointemploymentDetails.currentStep
  );

  const steps = useMemo<StepsComponent[]>(
    () => [
      <PartOne key="employment-details-part-one" />,
      <PartTwo key="employment-details-part-two" />,
      <PreviousEmployer key="previous-employer-details" />,
      <SecondEmployment key="second-employment-details" />,
    ],
    []
  );

  const renderStep = useMemo(() => {
    if (currentStep >= 0 && currentStep < steps.length) {
      return steps[currentStep];
    }
    return <PartOne />;
  }, [currentStep, steps]);

  return (
    <>
      <Layout>
        <JointStepper />
        {renderStep}
      </Layout>
    </>
  );
};

export default JointEmploymentDetails;
